/**
 * This file will handle the functionality of changing the values on size swatches, depending on the value of a
 * drop down menu
 */
define([
    'jquery'
], function ($) {
    'use strict';

    return {
        CONST__SIZE_CODE: 'size', //The unique code that is used for the size attribute
        CONST__MALE_OPTIONS: {
            'eum': 'EU Men',
            'sfm': 'US Men',
            'kfm': 'AU/UK Men'
        },
        CONST__FEMALE_OPTIONS: {
            'euw': 'EU Women',
            'sfw': 'AU/US Women'
        },
        CONST__BOYS_OPTIONS: {
            'kkm': 'UK Senior Standard Width',
            'dfm': 'US Senior Standard Width',
        },
        CONST__GIRLS_OPTIONS: {
            'kfs': 'UK Senior Narrow Width',
            'dfs': 'US Senior Narrow Width',
        },
        CONST__KIDS_OPTIONS: {
            'ukc': "UK Children",
            'usc': 'US Children',
            'euc': 'Euro Children',
        },
        CONST__NEWBORN_OPTIONS: {
            'uni': 'Universal'
        },

        /**
         * Get the <option>'s for the sizing system <select> drop down
         *
         * This function will loop through the global sizeChartData variable, and pull out all of the sizing systems
         * that are used
         *
         * @param maleSize boolean - return male sizes if requested, otherwise return female sizes.
         *
         * @returns {string}
         */
        getSizeSystemOptions: function(maleSize) {

            let options = (maleSize) ? this.CONST__MALE_OPTIONS : this.CONST__FEMALE_OPTIONS;

            let html = '';
            for (let code in options) {
                if (options.hasOwnProperty(code)) {
                    html = html + '<option value="' + code + '">' + options[code] + '</option>';
                }
            }
            return html;
        },


        getAllSizeSystemOptions: function(sizeGender) {

            let options = undefined;

            if (sizeGender === 'men') {
                options = this.CONST__MALE_OPTIONS;
            } else if (sizeGender === 'women') {
                options = this.CONST__FEMALE_OPTIONS;
            } else if (sizeGender === 'boys') {
                options = this.CONST__BOYS_OPTIONS;
            } else if (sizeGender === 'girls') {
                options = this.CONST__GIRLS_OPTIONS;
            } else if (sizeGender === 'kids') {
                options = this.CONST__KIDS_OPTIONS;
            }else if (sizeGender === 'newborn') {
                options = this.CONST__NEWBORN_OPTIONS;
            }

            let html = '';
            for (let code in options) {
                if (options.hasOwnProperty(code)) {
                    html = html + '<option value="' + code + '">' + options[code] + '</option>';
                }
            }
            return html;
        },

        /**
         * Get the sizes for each of the other sizing systems available
         *
         * @param {int} id The ID of the size to get the alternates for
         *
         * @private
         */
        getSizingSystemAlternates: function(id) {
            return sizeChartData[id];
        },

        /**
         * Helper function to simplify code - determines if option has one of the given size codes
         * @param optionId Size option ID
         * @param {array} sizeCodes Array of sizes to match on
         *
         * @returns {boolean}
         * @private
         */
        hasSizeProperty(optionId, sizeCodes) {
            if(sizeChartData.hasOwnProperty(optionId)) {
                let sizeCode;
                for (sizeCode in sizeCodes) {
                    if (sizeChartData[optionId].hasOwnProperty(sizeCodes[sizeCode])) {
                        return true;
                    }
                }
            }
            return false;
        },

        /**
         * Lookup the optionId in the sizechart data and check if it has male or female data attrs.
         *
         * @param optionId - a size option ID
         *
         * @returns {boolean}
         * @private
         */
        isMaleSize: function(optionId) {
            return this.hasSizeProperty(optionId, ['EUM']);
        },

        isFemaleSize: function(optionId) {
            return this.hasSizeProperty(optionId, ['EUW']);
        },

        isBoysSize: function(optionId) {
            return this.hasSizeProperty(optionId, ['KKM', 'DFM']);
        },

        isGirlsSize: function(optionId) {
            return this.hasSizeProperty(optionId, ['KFS', 'DFS']);
        },

        isKidsSize: function(optionId) {
            return this.hasSizeProperty(optionId, ['UKC', 'USC', 'EUC', 'CFP', 'DFP']);
        },

        isNewbornSize: function(optionId) {
            return this.hasSizeProperty(optionId, ['UNI']);
        },

        getSizeGender: function(optionId) {

            if (this.isGirlsSize(optionId)) {
                return 'girls';
            } else if (this.isBoysSize(optionId)) {
                return 'boys';
            } else if (this.isKidsSize(optionId)) {
                return 'kids';
            } else if (this.isMaleSize(optionId)) {
                return 'men';
            } else if (this.isNewbornSize(optionId)) {
                return 'newborn';
            } else {
                return 'women';
            }
        },


        /**
         * Returns true/false depending on whether the options being rendered are the size swatch options
         *
         * @param {jQuery} item The option being rendered
         *
         * @returns {boolean}
         * @private
         */
        isSizeSwatch: function(item) {
            return item.code === this.CONST__SIZE_CODE;
        },

        /**
         * Sets the switcher to the specified size system
         * @param system Sizing system
         * @param component
         */
        selectSizeSystem: function(system, component) {
            let $sizeSwitcher;
            let location = (typeof component !== 'undefined') ? component.name || '' : '';

            if (location === 'quickview') {
              let $quickViewContainer = $(".quickview-container");
              $sizeSwitcher = $quickViewContainer.find('.size-switcher');
            } else {
              $sizeSwitcher = $('.size-switcher');
            }

            $sizeSwitcher.val(system);
            $sizeSwitcher.trigger('automatically_update_size_system');
        }
    };
});
